// Round target prices above $30 while retaining consistent currency display.
export const formatTargetPrice = (value) => {
  if (value === null || value === undefined || value === "") return "n/a";
  const number = Number(value);
  if (!Number.isFinite(number)) return String(value);
  const rounded = number > 30 ? Math.round(number) : number;
  return rounded.toLocaleString("en-CA", { minimumFractionDigits: number > 30 ? 0 : 2, maximumFractionDigits: number > 30 ? 0 : 2 });
};
